export default __webpack_public_path__ + "static/media/rnr-sports-table-5-cn.c6225443.webp";